'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _coact = require('./coact');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_coact).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/coact/index.js
// module id = 497
// module chunks = 0